/* Texan Mattress Montgomery — conversion tracking
   Added by Cowork. Fires GA4 (gtag), GTM (dataLayer) and Meta (fbq) events for the
   actions that actually matter to a walk-in showroom:
     call_click      -> any tel: link tapped anywhere on the site   (Meta: Contact)
     get_directions  -> any Google Maps / directions link clicked   (Meta: FindLocation)
     financing_click -> Synchrony / Affirm / Acima / financing links(Meta: FinancingClick, custom)
     quiz_start      -> first answer chosen in the Sleep Quiz       (GA4 only)
     quiz_complete   -> Sleep Quiz result screen rendered           (Meta: Lead)
   Links inside a [data-tmx-no-track] element are ignored (e.g. the "read our Google
   reviews" link, which points at Maps but is not a directions request).
   Every tag call is guarded — if gtag/fbq/dataLayer isn't present, this quietly no-ops. */
(function () {
  'use strict';
  if (window.__tmxTrackingInitialized) return;
  window.__tmxTrackingInitialized = true;

  function fire(name, params) {
    params = params || {};
    if (window.Shopify && window.Shopify.designMode) return;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        var dl = { event: name };
        for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) dl[k] = params[k]; }
        window.dataLayer.push(dl);
      }
    } catch (e) {}
  }

  function meta(standardEvent, customEvent, params) {
    try {
      if (typeof window.fbq !== 'function') return;
      if (standardEvent) window.fbq('track', standardEvent, params || {});
      else if (customEvent) window.fbq('trackCustom', customEvent, params || {});
    } catch (e) {}
  }

  function label(el) {
    return (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);
  }

  /* ---------- 1. Calls  2. Directions  3. Financing (site-wide, delegated) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;
    if (a.closest('[data-tmx-no-track]') || a.hasAttribute('data-tmx-no-track')) return;
    var href = (a.getAttribute('href') || '').toLowerCase();
    if (!href) return;

    var namedEvent = a.getAttribute('data-tmx-event');
    if (namedEvent && namedEvent !== 'call_click' && namedEvent !== 'get_directions' && namedEvent !== 'financing_click') {
      fire(namedEvent, {
        link_text: label(a),
        brand: a.getAttribute('data-brand') || '',
        page_path: location.pathname
      });
    }
    if (a.closest('.announcement-bar, .announcement-bar-section')) {
      fire('sale_banner_click', { link_text: label(a), page_path: location.pathname });
    }

    if (href.indexOf('tel:') === 0) {
      fire('call_click', { method: 'website_tap', link_text: label(a), page_path: location.pathname, button_location: a.matches('.smcta-call') ? 'sticky_mobile_cta' : (a.getAttribute('data-tmx-placement') || 'page_link') });
      meta('Contact', null, { content_name: 'Phone call', content_category: 'Showroom' });
      return;
    }

    if (href.indexOf('maps.app.goo.gl') > -1 || href.indexOf('google.com/maps') > -1 ||
        href.indexOf('goo.gl/maps') > -1 || href.indexOf('maps.google.') > -1) {
      fire('get_directions', { link_text: label(a), page_path: location.pathname, button_location: a.matches('.smcta-dir') ? 'sticky_mobile_cta' : (a.getAttribute('data-tmx-placement') || 'page_link') });
      meta('FindLocation', null, { content_name: 'Get directions', content_category: 'Showroom' });
      return;
    }

    if (href.indexOf('financing') > -1 || href.indexOf('synchrony') > -1 ||
        href.indexOf('affirm') > -1 || href.indexOf('acima') > -1) {
      fire('financing_click', { link_text: label(a), page_path: location.pathname });
      meta(null, 'FinancingClick', { content_name: 'Financing' });
    }
  }, true);

  /* Only a server-confirmed contact submission is a lead. No form values are sent. */
  function initContactLead() {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var storageKey = 'tmx-contact-lead:' + location.pathname;
    form.addEventListener('submit', function () {
      try { sessionStorage.removeItem(storageKey); } catch (e) {}
    });
    if (!form.querySelector('[data-tmx-lead-success]')) return;
    try {
      if (sessionStorage.getItem(storageKey)) return;
      sessionStorage.setItem(storageKey, '1');
    } catch (e) {}
    fire('generate_lead', { lead_source: 'contact_form', form_id: 'ContactForm', page_path: location.pathname });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initContactLead);
  else initContactLead();

  function initFittingLead() {
    var form = document.getElementById('TmxFittingForm');
    if (!form || form.dataset.analyticsReady) return;
    form.dataset.analyticsReady = '1';
    var started = false, key = 'tmx-fitting-pending';
    function begin() { if (started) return; started = true; fire('fitting_request_start', { form_id: 'TmxFittingForm', page_path: location.pathname, placement: 'showroom_form' }); }
    form.addEventListener('input', begin, { once: true });
    form.addEventListener('change', begin, { once: true });
    form.addEventListener('submit', function () { if (form.checkValidity()) { try { sessionStorage.setItem(key, String(Date.now())); } catch(e) {} } });
    if (!form.querySelector('[data-tmx-fitting-success]')) return;
    var pending = 0;
    try { pending = Number(sessionStorage.getItem(key)); sessionStorage.removeItem(key); } catch(e) {}
    if (!pending || Date.now() - pending > 1800000) return;
    fire('fitting_request_success', { form_id: 'TmxFittingForm', page_path: location.pathname, placement: 'showroom_form' });
    fire('generate_lead', { lead_source: 'fitting_request', form_id: 'TmxFittingForm', page_path: location.pathname });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFittingLead);
  else initFittingLead();

  /* ---------- 4 & 5. Sleep Quiz (page body app, watched from the theme) ---------- */
  function initQuiz() {
    var quiz = document.getElementById('tmxQuiz');
    if (!quiz) return;
    var app = document.getElementById('qApp') || quiz;

    var started = false;
    quiz.addEventListener('click', function (e) {
      if (started) return;
      var opt = e.target && e.target.closest ? e.target.closest('.q-opt') : null;
      if (!opt) return;
      started = true;
      fire('quiz_start', { page_path: location.pathname });
    });

    var lastReported = null;
    var observer = new MutationObserver(function () {
      if (!app.querySelector('.q-res-hero')) return;

      var codeEl = app.querySelector('.q-code .code');
      var code = codeEl ? codeEl.textContent.trim() : '';
      var brandEl = app.querySelector('.q-rec .brand');
      var nameEl = app.querySelector('.q-rec h3');
      var rec = ((brandEl ? brandEl.textContent.trim() : '') + ' ' +
                 (nameEl ? nameEl.textContent.trim() : '')).replace(/\s+/g, ' ').trim();

      var key = code + '|' + rec;
      if (key === lastReported) return;
      lastReported = key;

      var params = {
        recommended_product: rec || 'unknown',
        pillow_code: code,
        page_path: location.pathname
      };
      fire('quiz_complete', params);
      meta('Lead', null, { content_name: 'Sleep Quiz', content_category: params.recommended_product });
    });
    observer.observe(app, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }
})();

